module.exports = __webpack_public_path__ + "img/svg/search.5ed6e3faec72f5254b8f7b75bba7ad0f.svg";